const SPRITE = 'https://iconic.dynamic-static-assets.com/icons/sprite.svg'

function icon(id) {
  return `${SPRITE}#${id}`
}

export const FEATURED_WALLETS = [
  { id: 'coinbase', name: 'Coinbase', icon: icon('coinbase'), iconTestId: 'wallet-icon-coinbase', recommended: true },
  { id: 'okx', name: 'OKX Wallet', icon: icon('okx'), iconTestId: 'wallet-icon-okxwallet', recommended: true },
  { id: 'metamask', name: 'MetaMask', icon: icon('metamask'), iconTestId: 'wallet-icon-metamask', recommended: true },
  { id: 'binance', name: 'Binance Wallet', icon: icon('binance'), iconTestId: 'wallet-icon-binance', recommended: true },
  { id: 'rabby', name: 'Rabby', icon: icon('rabby'), iconTestId: 'wallet-icon-rabby', recommended: true },
  { id: 'phantom', name: 'Phantom', icon: icon('phantom'), iconTestId: 'wallet-icon-phantomevm', recommended: true },
]

export const EXTRA_WALLETS = [
  { id: 'walletconnect', name: 'WalletConnect', icon: icon('walletconnect'), iconTestId: 'wallet-icon-walletconnect', recommended: false },
  { id: 'trust', name: 'Trust', icon: icon('trust'), iconTestId: 'wallet-icon-trust', recommended: false },
  { id: 'rainbow', name: 'Rainbow', icon: icon('rainbow'), iconTestId: 'wallet-icon-rainbow', recommended: false },
  { id: 'bitget', name: 'Bitget Wallet', icon: icon('bitgetwallet'), iconTestId: 'wallet-icon-bitget', recommended: false },
  { id: 'bybit', name: 'Bybit Wallet', icon: icon('bybit'), iconTestId: 'wallet-icon-bybit', recommended: false },
]
